export default "__VITE_ASSET__D6wUg62X__"